import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import Root from './routes/Root';
import View from './routes/View';
import PricingCalculator from './routes/PricingCalculator';

/** Doing the routes like this for now to accomodate the 2 different baseUrls used. */
export default createBrowserRouter(
    [
        {
            path: '/call-center-reservations',
            element: <Root />,
            children: [
                {
                    path: '',
                    element: <View />,
                },
            ],
        },
        {
            path: '',
            element: <Root />,
            children: [
                {
                    path: '',
                    element: <View />,
                },
            ],
        },
        {
            path: '/pricing-calculator',
            element: <PricingCalculator />,
        },
        // Embedded (WordPress shortcode) usage renders on whatever arbitrary
        // page path the host site put it on — a wildcard fallback so it
        // isn't limited to matching one of the explicit paths above.
        {
            path: '*',
            element: <Root />,
            children: [
                {
                    // A `*` parent's whole matched segment is the wildcard
                    // itself — an `index: true` child never matches against
                    // that, it only matches an exact/empty path. A nested `*`
                    // does match here, same as the parent.
                    path: '*',
                    element: <View />,
                },
            ],
        },
    ],
    {
        basename: '/',
    }
);
